<!-- SCRUM-141: the publish-form selects (e.g. "ישוב") were being filled by the
     browser's own autofill/form history (a stale "back-end/sale4youcode" entry
     showed instead of the placeholder). Chrome ignores autocomplete="off" for
     fields it classifies as address fields, so the inputs use an unrecognised
     token, which disables autofill; mat-autocomplete handles suggestions. -->
<form class="example-form" autocomplete="off">
  <mat-form-field fxFlex="100" class="example-full-width" [class.professional-select-field]="professional" appearance="fill">
    @if (dataStructure.title) {
      <mat-label>{{dataStructure.title}}</mat-label>
    }

    <!-- ═══════════════════════════════════════════════════════════
    MULTI-SELECT MODE — chips + autocomplete
    ═══════════════════════════════════════════════════════════ -->
    @if (multiSelect) {
      <mat-chip-grid #chipList>
        @for (item of selectedItems; track item) {
          <mat-chip-row
            [removable]="true"
            (removed)="removeItem(item)">
            {{ item }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-row>
        }
        <input #multiInput
          [formControl]="myControl"
          [matAutocomplete]="autoMulti"
          [matAutocompletePosition]="autocompletePosition"
          [matChipInputFor]="chipList"
          [placeholder]="searchPlaceholder || dataStructure.title"
          autocomplete="s4a-no-autofill"
          matInput
          (input)="onMySearch($event)"
          (focus)="onInputFocus(multiInput)"
          (blur)="onMobileInputBlur()">
        </mat-chip-grid>
        <mat-autocomplete #autoMulti="matAutocomplete" class="publish-autocomplete-panel"
          (optionSelected)="onOptionSelected($event)">
          @for (option of filteredOptions | async | filterByString: myControl.value; track option) {
            <mat-option
              [value]="option">
              <span class="select-option-content">
                <span class="select-multi-check-slot" aria-hidden="true">
                @if (isSelected(option)) {
                    <mat-icon class="select-option-check">check</mat-icon>
                }
                </span>
                <span class="select-option-label">{{ option }}</span>
              </span>
            </mat-option>
          }
        </mat-autocomplete>
      }

      <!-- ═══════════════════════════════════════════════════════════
      SINGLE-SELECT MODE — unchanged original template
      ═══════════════════════════════════════════════════════════ -->
      @if (!multiSelect) {
        <input #singleInput type="search"
          [formControl]="myControl"
          [matAutocomplete]="auto"
          [matAutocompletePosition]="autocompletePosition"
          [placeholder]="searchPlaceholder || dataStructure.title"
          [attr.aria-label]="ariaLabel || dataStructure.title"
          autocomplete="s4a-no-autofill"
          [(ngModel)]="myModel"
          class="input-field-focus"
          matInput
          (input)="onMySearch($event)"
          (focus)="onInputFocus(singleInput)"
          (blur)="onValueChange(); onMobileInputBlur()">
          <mat-autocomplete autoActiveFirstOption class="publish-autocomplete-panel" #auto="matAutocomplete"
            (optionSelected)="onOptionSelected($event)">
            @if (filteredOptions | async; as visibleOptions) {
              @for (option of visibleOptions | filterByString: myControl.value; track option) {
                <mat-option [value]="option">
                  <span class="select-option-content">
                    <span class="select-option-label">{{ option }}</span>
                    @if (option === myControl.value) {
                      <mat-icon class="select-option-check">check</mat-icon>
                    }
                  </span>
                </mat-option>
              } @empty {
                <mat-option disabled class="select-no-results">
                  <mat-icon>search_off</mat-icon>
                  <span>לא נמצאו תוצאות</span>
                </mat-option>
              }
            }
          </mat-autocomplete>
        }

      </mat-form-field>
    </form>
